// extracted by mini-css-extract-plugin
module.exports = {"dialogHeader":"Likes_dialogHeader__3jf1c","postLikesContainer":"Likes_postLikesContainer__ASB7m","badge":"Likes_badge__2eJsf"};